import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import PagingControl from "./PagingControl";

const ForwardControl = forwardRef(({ targetPage, children, small }, ref) => {
  return (
    <PagingControl
      ref={ref}
      direction="forward"
      targetPage={targetPage}
      small={small}
    >
      {children}
    </PagingControl>
  );
});

ForwardControl.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  small: PropTypes.bool,
  targetPage: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

ForwardControl.defaultProps = {
  small: false,
};

ForwardControl.displayName = "PagedMenuForwardControl";

export default ForwardControl;
